import {dynamicPropsFn} from './util.js'
const OpportunityList = resolve =>
  require(['@/views/Opportunity/List'], resolve)
const OpportunityDetail = resolve =>
  require(['@/views/Opportunity/Detail'], resolve)
const OpportunityEdit = resolve =>
  require(['@/views/Opportunity/Edit'], resolve)
const OppJobNumberList = resolve =>
  require(['@/views/Opportunity/OppJobNumber/List'], resolve)
const OppJobNumberDetail = resolve =>
  require(['@/views/Opportunity/OppJobNumber/Detail'], resolve)
const OppJobNumberEdit = resolve =>
  require(['@/views/Opportunity/OppJobNumber/Edit'], resolve)
const OppJobNumberNew = resolve =>
  require(['@/views/Opportunity/OppJobNumber/New'], resolve)
const ContactsList = resolve => require(['@/views/Contacts/ContactsList'], resolve)
const ContactsDetail = resolve => require(['@/views/Contacts/ContactsDetail'], resolve)
const ContactsNew = resolve => require(['@/views/Contacts/ContactsNew'], resolve)
const ContactsEdit = resolve => require(['@/views/Contacts/ContactsEdit'], resolve)
const OppCompetitorList = resolve => require(['@/views/Opportunity/OppCompetitor/List'], resolve)
const OppCompetitorDetail = resolve => require(['@/views/Opportunity/OppCompetitor/Detail'], resolve)
const OppCompetitorEdit = resolve => require(['@/views/Opportunity/OppCompetitor/Edit'], resolve)
const OppCompetitorNew = resolve => require(['@/views/Opportunity/OppCompetitor/New'], resolve)

const BusinessOpportunityList = resolve => require(['@/views/BusinessOpportunity/List'], resolve)
const BusinessOpportunityDetail = resolve => require(['@/views/BusinessOpportunity/Detail'], resolve)
const BusinessOpportunityEdit = resolve => require(['@/views/BusinessOpportunity/Edit'], resolve)
export default [
  {
    name: 'Opportunity_list',
    path: '/opportunity/list',
    component: OpportunityList,
    meta: {
      keepAlive: false,
      title: '商机列表',
    },
  },
  {
    name: 'Opportunity_detail',
    path: '/opportunity/list/detail',
    props: dynamicPropsFn,
    component: OpportunityDetail,
    meta: {
      keepAlive: false,
      title: '商机详情',
    },
  },
  {
    name: 'Opportunity_edit',
    path: '/opportunity/list/detail/edit',
    props: dynamicPropsFn,
    component: OpportunityEdit,
    meta: {
      keepAlive: false,
      title: '商机详情',
    },
  },
  {
    name: 'OppJobNumber_list',
    path: '/opportunity/list/detail/jobNumList',
    component: OppJobNumberList,
    meta: {
      keepAlive: false,
      title: '工号列表',
    },
  },
  {
    name: 'OppJobNumber_detail',
    path: '/opportunity/list/detail/jobNumList/jobNumDetail',
    props: dynamicPropsFn,
    component: OppJobNumberDetail,
    meta: {
      keepAlive: false,
      title: '工号详情',
    },
  },
  {
    name: 'OppJobNumber_edit',
    path: '/opportunity/list/detail/jobNumList/jobNumDetail/jobNumEdit',
    props: dynamicPropsFn,
    component: OppJobNumberEdit,
    meta: {
      keepAlive: false,
      title: '编辑工号',
    },
  },
  {
    name: 'OppJobNumber_new',
    path: '/opportunity/list/detail/jobNumList/jobNumNew',
    props: dynamicPropsFn,
    component: OppJobNumberNew,
    meta: {
      keepAlive: false,
      title: '新建工号',
    },
  },
  {
    name: 'Contacts_list',
    path: '/opportunity/list/detail/contactsList',
    component: ContactsList,
    meta: {
      keepAlive: false,
      title: '联系人列表',
    },
  },
  {
    name: 'contacts_detail',
    path: '/opportunity/list/detail/contactsList/contactsDetail',
    props: dynamicPropsFn,
    component: ContactsDetail,
    meta: {
      keepAlive: false,
      title: '联系人详情',
    },
  },
  {
    name: 'contacts_new',
    path: '/opportunity/list/detail/contactsList/contactsNew',
    props: dynamicPropsFn,
    component: ContactsNew,
    meta: {
      keepAlive: false,
      title: '联系人新建',
    },
  },
  {
    name: 'contacts_edit',
    path: '/opportunity/list/detail/contactsList/contactsDetail/contactsEdit',
    props: dynamicPropsFn,
    component: ContactsEdit,
    meta: {
      keepAlive: false,
      title: '联系人编辑',
    },
  },
  {
    name: 'OppCompetitor_list',
    path: '/opportunity/list/detail/oppCompetitorList',
    component: OppCompetitorList,
    meta: {
      keepAlive: false,
      title: '竞争对手列表',
    },
  },
  {
    name: 'OppCompetitor_detail',
    path: '/opportunity/list/detail/oppCompetitorList/oppCompetitorDetail',
    props: dynamicPropsFn,
    component: OppCompetitorDetail,
    meta: {
      keepAlive: false,
      title: '竞争对手详情',
    },
  },
  {
    name: 'OppCompetitor_edit',
    path: '/opportunity/list/detail/oppCompetitorList/oppCompetitorDetail/oppCompetitorEdit',
    props: dynamicPropsFn,
    component: OppCompetitorEdit,
    meta: {
      keepAlive: false,
      title: '竞争对手编辑',
    },
  },
  {
    name: 'OppCompetitor_new',
    path: '/opportunity/list/detail/oppCompetitorList/oppCompetitorNew',
    props: dynamicPropsFn,
    component: OppCompetitorNew,
    meta: {
      keepAlive: false,
      title: '竞争对手新建',
    },
  },
  {
    name: 'BusinessOpportunity_list',
    path: '/BusinessOpportunity/list',
    component: BusinessOpportunityList,
    meta: {
      keepAlive: false,
      title: '营业商机列表',
    },
  },
  {
    name: 'BusinessOpportunity_detail',
    path: '/BusinessOpportunity/detail',
    component: BusinessOpportunityDetail,
    meta: {
      keepAlive: false,
      title: '营业商机详情',
    },
  },
  {
    name: 'BusinessOpportunity_edit',
    path: '/BusinessOpportunity/edit',
    component: BusinessOpportunityEdit,
    props: dynamicPropsFn,
    meta: {
      keepAlive: false,
      title: '营业商机编辑',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/opportunity.js